import { render } from "./CreateWorkflowScreen.vue?vue&type=template&id=479c16fe"
import script from "./CreateWorkflowScreen.vue?vue&type=script&lang=ts"
export * from "./CreateWorkflowScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script